<template>
  <div>
    <div v-if="isUserGuide && showGuide" class="lxm-dashboard-user-guide">
      <div class="lxm-dashboard-user-guide_logo">
        <img src="https://s.lingxi360.com/register/%E7%BC%96%E7%BB%84%402x.png">
      </div>
      <div class="lxm-dashboard-user-guide_tip">
        <p class="lxm-dashboard-user-guide_tip-one">灵析手机端仅提供查询等操作</p>
        <p class="lxm-dashboard-user-guide_tip-two">请登录灵析电脑端，使用更多功能</p>
        <p class="lxm-dashboard-user-guide_tip-three">电脑端地址：www.lingxi360.com</p>
        <p class="lxm-dashboard-user-guide_tip-four">如果您目前不方便登录灵析电脑端</p>
        <p class="lxm-dashboard-user-guide_tip-five">可以先点击查看以下功能哦</p>
      </div>
      <div class="lxm-dashboard-user-guide_btns lxm-dashboard-user-guide_btns_first">
        <guide-item v-for="item in guideItems1"
                   :image="item.image"
                   :name="item.name"
                   :href="item.href"></guide-item>
      </div>
      <div class="lxm-dashboard-user-guide_btns">
        <guide-item v-for="item in guideItems2"
                   :image="item.image"
                   :name="item.name"
                   :href="item.href"></guide-item>
      </div>
      <div class="lxm-dashboard-user-guide_gift">
        登录有礼：24 小时内登陆灵析电脑端，可领取 <span>20元优惠券</span> 和 <span>新手大礼包</span> 哦。快去登录吧～
        <img src="https://s.lingxi360.com/register/mweb_hu.png">
      </div>
    </div>

    <div v-else class="lxm-dashboard-home page">
      <reg-source-tip></reg-source-tip>
      <h2 class="subtitle">最近七天</h2>
      <lxm-stat class="lxm-dashboard-home__stat"
                :stats="stats"></lxm-stat>

      <h2 class="subtitle">新鲜事</h2>
      <transition name="lxm-content-transition" mode="out-in">
        <guide v-if="showGuide"></guide>
      </transition>
      <template v-if="!showGuide">
        <div>
          <transition-group name="lxm-content-transition" tag="div" mode="out-in">
            <news-item v-for="n in news"
                      :key="n"
                      :title="n.title"
                      :data="n.data"
                      :dateTime="n.dateTime"></news-item>
          </transition-group>
        </div>
        <lxm-more v-if="hasMore"
                  :loading="loading"
                  :pureLoading="true"
                  @click="moreClicked"></lxm-more>
      </template>
    </div>

    <!--<lxm-bottom-tabs></lxm-bottom-tabs>-->
    <template v-if="!showGuide && !isUserGuide">
      <lxm-cover :doCover="doCover"></lxm-cover>
    </template>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../styles/index.styl'
  .lxm-dashboard-home
    background: white
    min-height: calc(100vh - 3.93rem - 3.93rem)
  .lxm-dashboard-home__stat
    padding-bottom: spacing
    border-bottom: 1px solid white-line
  .lxm-dashboard-user-guide
    max-height: calc(100vh - 3.93rem)
    height: calc(100vh - 3.93rem)
    background-image: url('https://s.lingxi360.com/register/bg@2x.jpg')
    background-size: cover
  .lxm-dashboard-user-guide_tip
    color: login-blue
    text-align: center
    margin-top: siz(35)
  .lxm-dashboard-user-guide_tip-one
    height: siz(29)
    line-height: siz(29)
    font-size: siz(14)
  .lxm-dashboard-user-guide_tip-two
    font-size: siz(20)
    font-weight: 500
    height: siz(29)
    line-height: siz(29)
    letter-spacing: siz(1)
    margin-top: siz(3)
  .lxm-dashboard-user-guide_tip-three
    font-size: siz(11)
    font-weight: 400
    height: siz(29)
    line-height: siz(29)
    margin-top: siz(7)
  .lxm-dashboard-user-guide_tip-four
    font-size: siz(12)
    font-weight: 400
    height: siz(29)
    line-height: siz(29)
    margin-top: siz(21)
  .lxm-dashboard-user-guide_tip-five
    font-size: siz(12)
    height: siz(29)
    line-height: siz(29)
    font-weight: 400
  .lxm-dashboard-user-guide_btns
    display: flex
    font-weight: 400
    color: login-blue
    font-size: siz(12)
    margin: 0 siz(32.5)
  .lxm-dashboard-user-guide_btns_first
    margin-top: siz(29)
  .lxm-dashboard-user-guide_gift
    width: 90%;
    margin: 0 auto
    color: #FF583B
    font-weight: 400
    font-size: siz(14)
    position: relative
    line-height: siz(20)
    background-repeat: round
    padding: siz(15) siz(30) siz(19) siz(10)
    background-image: url('https://s.lingxi360.com/register/popup_eclip_star@2x.png')
    span
      font-weight: bold
    img
      position: absolute
      right: siz(3)
      bottom: siz(3)
      width: siz(40)
  .lxm-dashboard-user-guide_logo
    width: 100%
    padding-top: siz(39)
</style>

<script>
  import LxmCover from '../common/LxmCover.vue'
  import LxmMenu from '../common/LxmMenu.vue'
  import LxmStat from '../common/LxmStat.vue'
  import Guide from './components/Guide.vue'
  import GuideItem from './components/GuideItem.vue'
  import NewsItem from './components/NewsItem.vue'
  import RegSourceTip from './components/RegSourceTip.vue'
  import LxmMore from '../common/LxmMore.vue'
  import LxmBottomTabs from '../common/LxmBottomTabs.vue'
  import LxmRegisterDialog from '@/components/common/LxmRegisterDialog'
  import * as aTypes from '../../../store/action-types'
  export default {
    components: {
      LxmCover,
      LxmMenu,
      LxmStat,
      Guide,
      NewsItem,
      RegSourceTip,
      LxmMore,
      LxmBottomTabs,
      LxmRegisterDialog,
      GuideItem
    },
    data () {
      return {
        guideItems1: [
          {
            name: '在线筹款',
            href: 'http://lxi.me/2qz9h',
            image: 'https://s.lingxi360.com/register/mweb_icon_choukuan%402x.png'
          },
          {
            name: '活动报名',
            href: 'http://lxi.me/h9c4h',
            image: 'https://s.lingxi360.com/register/mweb_icon_huodong%402x.png'
          },
          {
            name: '信息收集',
            href: 'http://lxi.me/52wgq',
            image: 'https://s.lingxi360.com/register/mweb_icon_xinxi%402x.png'
          }
        ],
        guideItems2: [
          {
            name: '个人中心',
            href: 'http://lxi.me/t6dif',
            image: 'https://s.lingxi360.com/register/mweb_icon_geren%402x.png'
          },
          {
            name: '捐赠公示',
            href: 'http://lxi.me/vaudf',
            image: 'https://s.lingxi360.com/register/mweb_icon_gongshi%402x.png'
          },
          {
            name: '传播互动',
            href: 'http://lxi.me/tf6xh',
            image: 'https://s.lingxi360.com/register/mweb_icon_chuanbo%402x.png'
          }
        ]
      }
    },
    mounted () {
      // 如需只加载一次 判断 this.$store.state.loading[aTypes.XXXX]
      // 为了切换用户刷新 不进行判断
      this.$store.dispatch(aTypes.DASHBOARD_GET_DIALOG)
      this.$store.dispatch(aTypes.DASHBOARD_GET_STAT)
      this.$store.dispatch(aTypes.DASHBOARD_GET_TEAM_INFO)
      this.$store.dispatch(aTypes.DASHBOARD_GET_NEWS, {
        page: 1,
        append: false
      })
      this.$store.dispatch(aTypes.ZHUGE_TRACK, { event: '到达工作面板' })
    },
    computed: {
      loading () {
        return this.$store.state.loading[aTypes.DASHBOARD_GET_NEWS]
      },
      currentPage () {
        return this.$store.state.dashboard.currentPage
      },
      stats () {
        return this.$store.state.dashboard.stats
      },
      news () {
        return this.$store.state.dashboard.news
      },
      hasMore () {
        return true
      },
      showGuide () {
        return !((this.news && this.news.length > 0) || this.loading)
      },
      isGifted () {
        return this.$store.state.dashboard.isGifted
      },
      isUserGuide () {
        return this.isGifted !== true
      },
      doCover () {
        return !this.$store.state.teamInfo.dataEnabled
      }
    },
    methods: {
      moreClicked () {
        this.$store.dispatch(aTypes.DASHBOARD_GET_NEWS, {
          page: this.currentPage + 1,
          append: true
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?219e701f